import type { Option as OptionType } from '../types'

export const checkForSelectedOption = (
  options: OptionType[],
  selectedValue?: number | string
) => {
  return options.filter((option) => option.value === selectedValue).length > 0
}
